import Component from '../abstracts/Component';
import queryString from 'query-string';
import doAjax from '../utils/ajaxUtil';
import { html } from 'htm/preact';
import algoliasearch from 'algoliasearch';
// import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { getAlgoliaResults } from '@algolia/autocomplete-preset-algolia';
import { autocomplete } from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';


export default class SearchLayerComponent extends Component {

  get SELECTORS() {
    return {
      closeBtn: '[data-search-close]',
      searchInput: '[data-search-input]',
      searchSuggestions: '[data-search-suggestions]',
      searchSuggestionsContainer: '[data-search-suggestions-container]',
      searchForm: '[data-search-form]',
      searchJsSubmit: '.js-search-submit',
      searchJsSubmitInput: '#search_field_box input',
      searchJsButton: '.js-search-button',
      burgerMenu: '[data-trigger-menu]',
      headerNav: '.c-m-h__menu-wrapper',
    };
  }

  get CSS_CLASSNAMES() {
    return {
      open: 'search-open',
      burgerOpen: 'menu-open'
    };
  }

  get CONST() {
    return {
      baseUrl: 'https://query-suggestions.eu.algolia.com',
      baseUri: '/1/configs',
      indexName: '/'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.searchInput = this.$component.querySelector(this.SELECTORS.searchInput);
    this.searchSuggestions = this.$component.querySelector(this.SELECTORS.searchSuggestions);
    this.searchSuggestionsContainer = this.$component.querySelector(this.SELECTORS.searchSuggestionsContainer);
    this.searchForm = this.$component.querySelector(this.SELECTORS.searchForm);
    this.searchJsSubmit = this.$component.querySelector(this.SELECTORS.searchJsSubmit);
    this.searchJsSubmitInput = this.$component.querySelector(this.SELECTORS.searchJsSubmitInput);
    this.searchJsButton = this.$component.querySelector(this.SELECTORS.searchJsButton);
    this.burgerMenu = document.querySelector(this.SELECTORS.burgerMenu);
    this.headerNav = document.querySelector(this.SELECTORS.headerNav);
    //
    this.searchFormUrl = this.searchForm.getAttribute('action');
    this.searchFormUrlJs = this.searchForm.getAttribute('data-js-search-url');
    this.input = this.$component.querySelector('input');
    this.scrollY = 0;
    this.searchIndex = this.$component.getAttribute('data-search-index');
    this.appID = this.$component.getAttribute('data-search-appID');
    this.apiKey = this.$component.getAttribute('data-search-apiKey');
  }

  openLayer() {
    this.$component.classList.add(this.CSS_CLASSNAMES.open);
    if (window.matchMedia('(max-width: 991px)').matches) {
      if(this.burgerMenu.classList.contains(this.CSS_CLASSNAMES.burgerOpen)){
        this.headerNav.style.zIndex = "";
        this.$component.style.zIndex = "2";
      }
      let benefitBar = document.querySelector('[data-benefit-bar]');
      let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
      this.scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${barHeight}px`;
      document.body.style.width = '100%';
    }
    if (this.input != null ) {
      this.input.focus();
    } else {
      let suggestionInput = document.querySelector('.aa-Input');
      if (suggestionInput != null) {
        suggestionInput.focus();
      }
    }
  }

  closeLayer() {
    this.$component.classList.remove(this.CSS_CLASSNAMES.open);
    if (window.matchMedia('(max-width: 991px)').matches) {
      this.$component.style.zIndex = "";
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, this.scrollY);
    }
  }

  listenClose() {
    if (!this.closeBtn) {
      return;
    }
    this.closeBtn.addEventListener('click', () => {
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    });
  }

  getSuggestion(index,search = false) {
    let ctx = this;
    // X-Algolia-Application-Id: the application ID.
    // X-Algolia-API-Key: the admin API key for given application ID.
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);
    //
    autocomplete({
      debug: true,
      container: '#l-s__search',
      panelContainer: '#l-s__suggestions',
      placeholder: ctx.$component.dataset.searchPlaceholder ,
      detachedMediaQuery: 'none',
      getSources({ query }) {
        return [
          {
            sourceId: 'querySuggestions',
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: index,
                    query,
                  },
                ],
              });
            },
            getItemUrl({ item }) {
              return item.url;
            },
            getItemInputValue({ item }) {
              return item.query;
            },
            templates: {
              header() {
                return '';
              },
              item({ item }) {
                // console.log(item);
                return html`<a href="${item.link}">${item.title} <span class="color"> ${item.color} </span></a>`;
              },
              footer() {
                return '';
              },
            },
          },
        ];
      },

    });

  }


  // bind keyup
  bindSearch() {
    let ctx = this;
    let timer;
    let index = ctx.$component.dataset.searchIndex;
    //ctx.$component.dataset.searchEnv + '_' + ctx.$component.dataset.searchBrand.toLowerCase() + '_' + ctx.$component.dataset.searchCountry + '_' + ctx.$component.dataset.searchLanguage;
    //
    ctx.getSuggestion(index);
  }

  jsSearchPage() {
    // get autocomplete value
    let autocompleteInput = this.$component.querySelector(this.SELECTORS.searchJsSubmitInput);
    if(autocompleteInput.value.trim() === "") {
      return;
    } else {
      // build url
      let url = this.searchFormUrlJs+'?text='+autocompleteInput.value;
      // go to url
      window.location.href = url;
    }
  }

  bindEvents() {
    let ctx = this;
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      this.openLayer();
    });
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      this.closeLayer();
    });

    // if suggestions are enabled, i want to keep the standard search working
    if (this.searchJsSubmit != null) {
      this.searchJsSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        // go
        this.jsSearchPage();
      });
      // enables Enter key to submit search
      this.searchForm.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          // go
          ctx.jsSearchPage();
        }
      });
    }
    //prevent searching empty text
    if(this.searchJsButton != null) {
      this.searchJsButton.addEventListener('click', (e) => {
        if(this.searchJsSubmitInput.value.trim() === "") {
          e.preventDefault();
          return;
        }
      });
      // enables Enter key to submit search
      this.searchForm.addEventListener('keypress', (e) => {
        if (e.keyCode === 13 && this.searchJsSubmitInput.value.trim() === "") {
          e.preventDefault();
          return;
        }
      });
    }
  }

  render() {
    super.render();
    this.listenClose();
    this.bindEvents();
    // if is enabled
    if ( this.$component.attributes['data-search-suggestions'].nodeValue == 'true' ) {
      this.bindSearch();
    }
  }
}
